import React from "react";
import { Button } from "reactstrap";

const ReportHit = ({ report, index }) => {
  const statusLabel = {
    pending: "Pendiente",
    processing: "Generando",
    completed: "Completado",
    failed: "Error"
  }[report.status];

  const filters = report.filters || {};
  const hasPublicationFilter = filters.publication_id;

  const renderRangeInfo = () => {
    if (report.report_type === "postulations" && hasPublicationFilter) {
      return (
        <span className="text-muted">
          Publicación: {filters.publication_title || `ID: ${filters.publication_id}`}
        </span>
      );
    } else if (filters.start_date && filters.end_date) {
      return `${filters.start_date} → ${filters.end_date}`;
    } else {
      return "-";
    }
  };

  return (
    <tr>
      <td>{index + 1}</td>
      <td>{renderRangeInfo()}</td>
      <td>{statusLabel}</td>
      <td>{new Date(report.created_at).toLocaleString()}</td>
      <td>{report.user_email}</td>
      <td>
        {report.file_url && report.status === "completed" ? (
          <a href={report.file_url} download>
            <Button color="success" size="sm">Descargar {report.file_url.endsWith(".xlsx") ? "XLSX" : "CSV"}</Button>
          </a>
        ) : (
          <span className="text-muted small">
            {report.status === "failed" ? "Error" : "En proceso..."}
          </span>
        )}
      </td>
    </tr>
  );
};

export default ReportHit;
